module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBoldItalic.b10b708f.ttf";